// tienda/ModalidadesSection.jsx

import React from "react";
import { motion } from "framer-motion";
import { Package, Store } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";
import { TierCard } from "./TierCard";

export function ModalidadesSection() {
  return (
    <section className="border-b bg-white" style={{ borderColor: brand.line }}>
      <div className="mx-auto max-w-7xl px-4 py-14 md:py-20">
        <motion.div {...fadeUp} className="mb-9 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-3 text-xs font-black uppercase tracking-[0.2em]" style={{ color: brand.primary }}>
              Modalidades
            </p>
            <h2 className="max-w-2xl text-3xl font-black md:text-4xl" style={{ color: brand.ink }}>
              Elige entre recojo en tienda o fulfillment desde Fast Max.
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed" style={{ color: brand.muted }}>
            Same-day en Lima y Callao; despacho nacional desde almacén con Olva y Shalom.
          </p>
        </motion.div>

        <div className="grid gap-4 md:grid-cols-2">
          <TierCard
            icon={<Store className="size-5" />}
            tag="Tienda estándar"
            tagColor={brand.accentGold}
            title="Recojo desde tu tienda"
            price="S/ 9.90"
            cutoff="Corte 12:00 PM"
            delivery="Entrega Lima same-day antes de 8 PM"
            perks={[
              "Registra pedidos hasta las 11 AM",
              "Seguimiento en vivo para ti y tu cliente",
              "WhatsApp automático en cada estado",
              "Cobro contraentrega incluido en Lima",
            ]}
          />
          <TierCard
            icon={<Package className="size-5" />}
            tag="Provider · almacén FM"
            tagColor={brand.accentGreen}
            title="Tu stock en nuestro almacén"
            price="S/ 8.90"
            cutoff="Corte 2:00 PM"
            delivery="Fulfillment para Lima y envíos a todo Perú"
            featured
            perks={[
              "Envía tu stock a nuestro almacén",
              "Cierra ventas hasta las 2:00 PM",
              "Procesamos y despachamos el mismo día",
              "Inventario en tiempo real en tu panel",
              "Envíos nacionales con Olva y Shalom",
            ]}
          />
        </div>
      </div>
    </section>
  );
}
